function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M26,6V8H18V6Zm9,4v2H18V10Zm0,4v2H18V14ZM10,17v2H6V17ZM3,17v2H2v1H0V17Zm32,1v2H18V18ZM2,23v4H0V23Zm33,3v2H27V26ZM38,2H15V32H38ZM2,30v4H0V30ZM40,0V34H13V0ZM2,37v1H3v2H0V37Zm8,1v2H6V38Zm14,0v2H20V38Zm-7,0v2H13V38Zm13-1v3H27V38h1V37Z"
});

var SvgDragAndDropDocument = function SvgDragAndDropDocument(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDragAndDropDocument, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/drag-and-drop-document.e14b23f4.svg";
export { ForwardRef as ReactComponent };